import * as constants from "./constants";

const initialState = {
  allHistory: [],
  fetchingLoading: true,
  updateLoading: false,
  // totalRecords: 0,
  isAdding: false,
  search: {},
};

const HistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.FETCH_ENROLLMENT_HISTORY:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.FETCH_ENROLLMENT_HISTORY_SUCCESS:
      return {
        ...state,
        fetchingLoading: false,
        allHistory: action.payload,
        isAdding: false,
      };
    case constants.FETCH_ENROLLMENT_HISTORY_ERROR:
      return {
        ...state,
        fetchingLoading: false,
        isAdding: false,
      };

    case constants.IS_ADDING_UPDATE:
      return {
        ...state,
        isAdding: action.data,
      };

    case constants.SET_ENROLLMENT_HISTORY_MANAGER_STATE:
      const { search } = state;

      localStorage.setItem(
        "historyManagerState",
        JSON.stringify({ search, ...action.data })
      );
      return {
        ...state,
        ...action.data,
      };

    default:
      return state;
  }
};

export default HistoryReducer;
